import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { GdFreelancerStatus } from '../../typings/graphql-grid';

import './FreelancerBusyStatus.css';
import * as keyset from './FreelancerBusyStatus.i18n';

const i18n = i18nFactory(keyset);

export interface FreelancerBusyStatusProps {
    status: GdFreelancerStatus;
    cls?: string;
    isPageOwner: boolean;
    isCooperating?: boolean;
}

export class FreelancerBusyStatus extends React.PureComponent<FreelancerBusyStatusProps> {
    getStatus(status: GdFreelancerStatus, isPageOwner: boolean): { text: string; mod: string } {
        if (this.props.isCooperating) {
            return {
                text: i18n('freelancer-is-cooperating'),
                mod: 'is-cooperating'
            };
        }
        switch (status) {
            case GdFreelancerStatus.BUSY:
                return {
                    text: isPageOwner ? i18n('freelancer-is-busy-is-owner') : i18n('freelancer-is-busy'),
                    mod: 'is-busy'
                };
            case GdFreelancerStatus.FREE:
                return {
                    text: isPageOwner ? i18n('freelancer-is-free-is-owner') : i18n('freelancer-is-free'),
                    mod: 'is-free'
                };
            default:
                throw new Error('unknown cooperation status (we know only BUSY and FREE)');
        }
    }
    render() {
        const { status, cls, isPageOwner } = this.props;
        const currentStatus = this.getStatus(status, isPageOwner);
        return (
            <span
                className={classNames(
                    Bem.cls({
                        block: 'busy-status',
                        mods: { status: currentStatus.mod }
                    }),
                    cls
                )}
            >
                {currentStatus.text}
            </span>
        );
    }
}
